import { EventChart } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import store from "@/store";

export function handleClickChart(
  indexSection: number,
  indexCollection: number,
  chartType: string,
  event: any
) {
  try {
    let values: string[];
    if (event.seriesName) {
      // 🔹 Caso agrupación (ej: stackedColumn)
      values = event.seriesName.split(" - ");
      values.push(event.name);
      values = values.reverse();
    } else {
      // 🔹 Caso simple (ej: doughnut)
      values = [event.name];
    }

    store.commit("setEventChart", {
      indexSection,
      indexCollection,
      values,
      chartType: chartType
    } as EventChart);
  } catch (error) {
    console.error(error);
  }
}
